import { ColumnsType } from "antd/es/table";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { ISubAccountData } from "@/store/SubAccountStore";
import { StatusText } from "@/pages/child-customer/components/status-text";
import { ChildBalance } from "@/pages/child-customer/view/child-manage/components/child-balance";
import { ChildCoupon } from "@/pages/child-customer/view/child-manage/components/child-coupon";
import { ChildPermission } from "@/pages/child-customer/view/child-manage/components/child-permission";
import { ChildOperation } from "@/pages/child-customer/view/child-manage/components/child-operation";
import { ChildUsername } from "@/pages/child-customer/view/child-manage/components/child-username";
import { RemarkCell } from "@/pages/child-customer/components/remark-cell";
const t = getTranslateNsT("center");

export const columns: ColumnsType<ISubAccountData> = [
  {
    title: t("user_com_childManage_head_sub_name"),
    render: ({ subUserName }) => <ChildUsername subUserName={subUserName} />,
  },
  {
    title: t("user_com_childManage_head_tel"),
    dataIndex: "phone",
  },
  {
    title: t("user_com_childManage_head_email"),
    dataIndex: "email",
  },
  {
    title: t("user_com_childManage_head_remark"),
    render: (v) => <RemarkCell {...v} />,
  },
  {
    title: t("user_com_childManage_head_status"),
    render: ({ status }) => (
      <StatusText
        status={status}
        text={t(`user_com_childManage_head_status_${status}`)}
      />
    ),
  },
  {
    title: t("user_com_childManage_head_balance"),
    render: (v) => <ChildBalance {...v} />,
  },
  {
    title: t("user_com_childManage_head_desktop"),
    dataIndex: "cloudCoupon",
    render: (v) => (v ? `￥${v}` : ""),
  },
  {
    title: t("user_com_childManage_head_coupon"),
    render: (v) => <ChildCoupon {...v} />,
  },
  {
    title: t("user_com_childManage_head_credit"),
    dataIndex: "credit",
  },
  {
    title: t("user_com_childManage_head_privilege"),
    render: (v) => <ChildPermission {...v} />,
  },
  {
    title: t("user_com_childManage_head_handle"),
    render: (v) => <ChildOperation {...v} />,
  },
];
